import React from "react";
import { CharacterHistoryContext } from "../contexts/CharacterHistoryContext";

export default () => {
  const { revisionHistory, revisionNumber, jumpTo } = React.useContext(
    CharacterHistoryContext
  );
  const revisions = Array(revisionHistory.length)
    .fill(0)
    .map((item: any, i: number) => {
      const desc = i ? `Revision #${i}` : "Back to Start";
      return (
        <option value={i} key={`revision-${i}`}>
          {desc}
        </option>
      );
    });
  return (
    <select
      value={revisionNumber}
      className="textCell inline-select inline-select-background"
      onChange={(event) => jumpTo(parseInt(event.target.value))}
    >
      {revisions}
    </select>
  );
};
